export default "__VITE_ASSET__BhgSVzmZ__"